import React from "react";
import { NoFeedIcon, WidgetBuildingIcon } from "../Icons/icons.component";

export default function NoDataMessage({ isWidget, text, subtext }) {
  return (
    <div className="noFilterDataWrap">
      {isWidget ? <WidgetBuildingIcon /> : <NoFeedIcon />}
      {text && <h6>{text || "No Feeds Found"}</h6>}
      {subtext && (
        <p>
          {subtext ||
            "Try adjusting the filters to find what you’re looking for"}
        </p>
      )}
    </div>
  );
}
